// src/hooks/useStories.js
import {useEffect, useState} from "react";
import {stories as fallbackStories} from "../data/StoriesData";

export function useStories() {
  const [stories, setStories] = useState(fallbackStories);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        console.log("[useStories] fetching /api/stories...");
        const res = await fetch("/api/stories");

        if (!res.ok) {
          throw new Error(`[useStories] HTTP ${res.status}`);
        }

        const data = await res.json();
        console.log("[useStories] response:", data);

        let nextStories;

        // /api/stories returns a plain array -> [ {...}, {...} ]
        if (Array.isArray(data)) {
          nextStories = data;
        }
        // or { stories: [...] }
        else if (Array.isArray(data.stories)) {
          nextStories = data.stories;
        }
        // or { items: [...] }
        else if (Array.isArray(data.items)) {
          nextStories = data.items;
        } else {
          throw new Error(
            "[useStories] Unexpected data shape from /api/stories"
          );
        }

        if (!cancelled) {
          setStories(nextStories);
        }
      } catch (err) {
        console.error(
          "[useStories] falling back to bundled StoriesData.js:",
          err
        );
        if (!cancelled) {
          setError(err);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return {stories, loading, error};
}
